import type { StatusTone } from '@noor/ui';

/**
 * Pure presentational mappers for the `conversation` entity (no React). The
 * entity decides which `StatusTone` a domain value maps to; the `@noor/ui`
 * components stay domain-agnostic (CLAUDE.md).
 */

/** Presence → status-badge tone: online reads success (green), offline neutral. */
export function onlineToTone(online: boolean): StatusTone {
  return online ? 'success' : 'neutral';
}
